
import React from 'react';
import { PeriodPrediction } from './periodCalculatorTypes';

interface PeriodCalculatorResultsProps {
  results: {
    predictions?: PeriodPrediction[];
    message?: string;
  };
}

const PeriodCalculatorResults: React.FC<PeriodCalculatorResultsProps> = ({ results }) => {
  if (results.message) {
    return (
      <div className="mt-4 p-4 bg-red-50 text-red-700 rounded-md">
        {results.message}
      </div>
    );
  }
  
  if (results.predictions) {
    return (
      <div className="mt-6 space-y-4">
        <div className="p-4 border rounded-md">
          <h4 className="text-lg font-medium mb-4">Period & Fertility Predictions</h4>
          <div className="space-y-5">
            {results.predictions.map((prediction, idx) => (
              <div key={idx} className={`p-3 rounded-md ${idx === 0 ? 'bg-primary/10' : 'bg-muted'}`}>
                <h5 className={`font-medium mb-2 ${idx === 0 ? 'text-primary' : ''}`}>
                  {idx === 0 ? 'Next Period' : `Period ${idx + 1}`}
                </h5>
                <div className="space-y-1 text-sm">
                  <p><span className="font-medium">Period:</span> {prediction.periodStart} to {prediction.periodEnd}</p>
                  <p><span className="font-medium">Fertile Window:</span> {prediction.fertileStart} to {prediction.fertileEnd}</p>
                  <p><span className="font-medium">Ovulation Date:</span> {prediction.ovulationDate}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="text-sm text-muted-foreground">
          <p>Note: These predictions are estimates based on your average cycle. Many factors can affect your menstrual cycle, including stress, diet, exercise, and health conditions. For the most accurate tracking, log your periods consistently and consider using additional fertility tracking methods.</p>
        </div>
      </div>
    );
  }
  
  return null;
};

export default PeriodCalculatorResults;
